import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TemplatePreview.css';

function TemplatePreview({ template, onClose }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    loadPreview(null);
    // Optionally load company list for selecting real sample data
    loadCompanies();
  }, [template]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadPreview = async (companyId) => {
    try {
      setLoading(true);
      const response = await axios.post(`/api/email-templates/${template.id}/preview`, {
        company_id: companyId
      });
      setPreview(response.data);
      setSelectedCompanyId(companyId);
    } catch (error) {
      console.error('Failed to load preview:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadCompanies = async () => {
    try {
      const response = await axios.get('/api/companies', { params: { limit: 10, offset: 0 } });
      setCompanies(response.data.data);
    } catch (error) {
      console.error('Failed to load companies:', error);
    }
  };

  const handleCompanySelect = (e) => {
    const companyId = e.target.value ? parseInt(e.target.value) : null;
    if (companyId) {
      loadPreview(companyId);
    } else {
      loadPreview(null);
    }
  };

  return (
    <div className="template-preview">
      <h2>📧 Template Preview - {template.name}</h2>

      <div className="preview-controls">
        <label>
          Preview with sample company:
          <select value={selectedCompanyId || ''} onChange={handleCompanySelect} disabled={loading}>
            <option value="">Sample Data</option>
            {companies.map(company => (
              <option key={company.id} value={company.id}>
                {company.name} - {company.email}
              </option>
            ))}
          </select>
        </label>
      </div>

      {loading ? (
        <div className="loading">Loading preview...</div>
      ) : preview ? (
        <div className="preview-content">
          {/* Subject Preview */}
          <div className="preview-section">
            <h3>Subject Line</h3>
            <div className="subject-preview">
              {preview.subject}
            </div>
          </div>

          {/* Email Body Preview */}
          <div className="preview-section">
            <h3>Email Body</h3>
            <div className="email-preview">
              <div 
                className="email-content" 
                dangerouslySetInnerHTML={{ __html: preview.html }}
              />
            </div>
          </div>

          {/* Sample Data Used */}
          <div className="preview-section">
            <h3>Sample Data Used</h3>
            <div className="sample-data-table">
              <table>
                <tbody>
                  {Object.entries(preview.sample_data).map(([key, value]) => (
                    <tr key={key}>
                      <td className="key">{key}</td>
                      <td className="value">{value || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* HTML Preview */}
          <div className="preview-section">
            <details>
              <summary>📄 View HTML Source</summary>
              <pre className="html-source">{preview.html}</pre>
            </details>
          </div>
        </div>
      ) : (
        <div className="no-preview">Failed to load preview</div>
      )}

      <div className="preview-actions">
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

export default TemplatePreview;
